/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import { sdShowToast } from "helpers/sdHelper";
import React, { useState, useEffect } from "react";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { sdCreateOrUpdateCustomer } from "services/service-desk/sdService";


const createOption = (label, value) => ({
    label,
    value
});

const SDCreatableUserSelect = ({ initialValue, onUpdate, users, hasInitialOption, quickLinkShow, quickLinkId, quickLinkText, projectId }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        let o = []
        if (hasInitialOption) {
            o.push({ label: 'Unassigned', value: 0 });
        }
        console.log("SDCreateableUserSelect ", users);

        if (users) {
            users.map((user) => {
                let name = user.displayName != user.email ? `${user.displayName} (${user.email})` : `${user.email}`
                o.push({ label: name, value: user.id });
            });
        }
        setOptions(o);
        console.log(o);
    }, []);

    const handleCreate = (inputValue) => {
        setIsLoading(true);

        sdCreateOrUpdateCustomer(inputValue, projectId).then(res => {
            sdShowToast("New user created", false);
            console.log("sdCreateOrUpdateCustomer", res.data);
            // TODO: don't add new option if it already exists!
            const newOption = createOption(res.data.email, res.data.id);
            setIsLoading(false);
            setOptions((prev) => [...prev, newOption]);
            setValue(newOption.value);
            onUpdate(newOption.value);
        }).catch(err => {
            sdShowToast("Failed to create user", false);
            console.error(err);
        });
    };

    const handleChange = (selectedOption) => {
        const newValue = selectedOption?.value || null
        setValue(newValue);
        console.log("Value changed!!", newValue);
        onUpdate(newValue);
    };

    return (
        <CreatableSelect
            isClearable
            isDisabled={isLoading}
            isLoading={isLoading}
            onChange={handleChange}
            onCreateOption={handleCreate}
            options={options}
            value={options.find(opt => opt.value === value)}
        />
    );

};

export default SDCreatableUserSelect;
